// Public API Keys - Safe to store in frontend with domain restrictions
// These keys are restricted to specific domains in Google Cloud Console

// Environment detection with SSR safety and caching
let cachedEnvironment = null;

export const getEnvironment = () => {
  // Return cached value if already determined
  if (cachedEnvironment !== null) {
    return cachedEnvironment;
  }

  // Check if window is available (SSR safety)
  if (typeof window === 'undefined' || !window.location) {
    // Default to staging during SSR or when window is not available
    cachedEnvironment = 'staging';
    return cachedEnvironment;
  }

  // Determine environment based on hostname
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    cachedEnvironment = 'staging'; // Use staging for local development
  } else if (hostname.includes('staging') || 
             hostname.includes('domusiq-staging-env') ||
             hostname.includes('vatesdomusstaging')) {
    cachedEnvironment = 'staging';
  } else {
    cachedEnvironment = 'production';
  }

  return cachedEnvironment;
};

// Firebase Configuration - Environment-specific configs
const FIREBASE_CONFIGS = {
  development: {
    apiKey: "AIzaSyB9m3H9FBONpTCn54VQQpvn-DdbbMHKNe0",
    authDomain: "gen-lang-client-0307709712.firebaseapp.com",
    projectId: "gen-lang-client-0307709712",
    storageBucket: "gen-lang-client-0307709712.appspot.com",
    messagingSenderId: "723716649551",
    appId: "1:723716649551:web:f4a51afecab8259570b03a"
  },
  staging: {
    apiKey: "AIzaSyBUXT0iDz6Z5EFnG6IZG8V0H5X0PL6WvK4",
    authDomain: "vatesdomusstaging.com",
    projectId: "domusiq-staging-env",
    storageBucket: "domusiq-staging-env.firebasestorage.app",
    messagingSenderId: "1060835462812",
    appId: "1:1060835462812:web:8680808379540866b22759"
  },
  production: {
    apiKey: "AIzaSyB9m3H9FBONpTCn54VQQpvn-DdbbMHKNe0",
    authDomain: "vatesdomusai.com",
    projectId: "gen-lang-client-0307709712",
    storageBucket: "gen-lang-client-0307709712.firebasestorage.app",
    messagingSenderId: "723716649551",
    appId: "1:723716649551:web:f4a51afecab8259570b03a"
  }
};

// Export the appropriate Firebase config based on environment
export const FIREBASE_CONFIG = FIREBASE_CONFIGS[getEnvironment()];

// Stripe Publishable Keys - Safe to store in frontend with domain restrictions
const STRIPE_PUBLISHABLE_KEYS = {
  development: 'pk_test_51SABEhGg3zhMEMp9FQjL4zazEOdJwei17ux9LLTKhI7umorLYusomIRUzw6EKwNxOiDCCKi8F2kw1FMPoDZzHss3003senp3pH', // Staging key for localhost
  staging: 'pk_test_51SABEhGg3zhMEMp9FQjL4zazEOdJwei17ux9LLTKhI7umorLYusomIRUzw6EKwNxOiDCCKi8F2kw1FMPoDZzHss3003senp3pH', // Staging-specific key
  production: 'pk_live_51S3eSjGshSjnQ0dvLHmW9d0dzX2IhSG5dqPbdf55AUU8m9XP7Wc3SQa62LMBMyRz09lKAcKXrBC0gr1LexhEmhkY00DFQm1AhD' // Live key for production
};

export const STRIPE_PUBLISHABLE_KEY = STRIPE_PUBLISHABLE_KEYS[getEnvironment()];

// Google Maps API Keys - Domain-restricted in Google Cloud Console
const GOOGLE_MAPS_KEYS = {
  staging: {
    apiKey: 'AIzaSyANnioYPIcrZHqMNWUb8C30EBBls8boCXo',
    mapId: '14b67f323e3742e317353500',
  },
  production: {
    apiKey: 'AIzaSyB9m3H9FBONpTCn54VQQpvn-DdbbMHKNe0',
    mapId: 'c3569d37448529daa04a38db',
  },
};

const mapsEnv = GOOGLE_MAPS_KEYS[getEnvironment()] || GOOGLE_MAPS_KEYS.staging;
export const GOOGLE_MAPS_API_KEY = mapsEnv.apiKey;
export const GOOGLE_MAPS_MAP_ID = mapsEnv.mapId;

// reCAPTCHA v3 Site Keys - Public by design, used for App Check
const RECAPTCHA_SITE_KEYS = {
  staging: '6LeTVBcsAAAAAIlmDQSEOXQEQCnLcsjqKPygi1zU',
  production: '6LfnVRcsAAAAAB-KPcVh9GMaBt4dcEpTHLyT0jpc',
};

export const RECAPTCHA_SITE_KEY = RECAPTCHA_SITE_KEYS[getEnvironment()] || RECAPTCHA_SITE_KEYS.staging;
